import { useStore } from '../store'
import { route } from 'quasar/wrappers'
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from 'vue-router'
import routes from './routes'
import { Loading } from 'quasar'
export interface StateInterface {
  usePageTransition: boolean
  iosBrowserSwipingBack: boolean
}

export default route<StateInterface>(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE),
  })

  Router.beforeEach((to) => {
    const store = useStore()
    const isLoggedIn = store.user.isLoggedIn

    if (to.path !== '/login' && to.path !== '/recap') {
      // If not going to the login or recap preview page, redirect back to login
      return isLoggedIn ? true : '/login'
    }

    if (to.path === '/recap') {
      // If we're going to preview a recap, approve the route change
      return true
    }

    // Path is to the login page
    // Block going to the login page if already logged in

    return !isLoggedIn
  })

  // Spy on each route change
  Router.beforeEach((to, from) => {
    const store = useStore()
    store.spy.addEvent({
      timestamp: new Date(),
      type: 'route',
      data: {
        to: to.fullPath,
        from: from.fullPath,
      },
    })
  })

  //show a spinner if load btwn routes takes more than 300ms. Set in quasar.conf.js w/ 'Loading' plugin
  Router.beforeEach(async () => {
    Loading.show()
  })
  Router.afterEach(() => {
    Loading.hide()
  })

  return Router
})
